export default "__VITE_ASSET__BKRbA3LQ__"